
import videoStyles from '../../../shared/stylesheets/video.css'
import { getPositionClasses } from '../../utils/alignment-classes'
// import { getInitialMuteButton } from './muteButtons'

export const videoHandler = {
  property: 'data-video-element',
  load: (card) => {
    const elem = document.createElement('div')
    elem.id = card.getAttribute('data-background-id')

    const videoSrc = {
      poster: card.getAttribute('data-video-poster-image') || '',
      mp4: card.getAttribute('data-video-mp4') ||  '',
      webm: card.getAttribute('data-video-webm') ||  '',
      subtitles: card.getAttribute('data-video-subtitles') || ''
    }

    const desktopAlignment = card.getAttribute('data-background-align') ||  ''
    const mobileAlignment = card.getAttribute('data-background-align-mobile') ||  ''

    let alignmentClasses = '';
    if (desktopAlignment || mobileAlignment) {
      alignmentClasses = getPositionClasses(desktopAlignment, mobileAlignment)
    }

    const webmElement = videoSrc.webm ? `<source type="video/webm" src="${videoSrc.webm}">` : ''
    const mp4Element = videoSrc.mp4 ? `<source type="video/mp4" src="${videoSrc.mp4}">` : ''

    const trackElement = videoSrc.subtitles ? `<track src="${videoSrc.subtitles}" kind="caption" srclang="no" label="Norwegian" default=""></track>` : ''


    const videoElement = `
      <video
        loop

        muted=""
        preload="none"
        poster="${videoSrc.poster}"
        playsinline=""
        class="
          ${videoStyles['video']}
          ${alignmentClasses}
          "
      >
        ${webmElement}
        ${mp4Element}
        Your browser does not support the video tag. We suggest you upgrade your browser.
      </video>
      <div class="${videoStyles['subtitlescontainer']}"></div>
    `
    elem.innerHTML = videoElement


    return elem
  }
}




// WEBPACK FOOTER //
// ./src/client/sections/video/index.js